<section id="dynamic-ngx-table">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">

            <!-- DATATABLE -->
            <ngx-datatable class="bootstrap core-bootstrap" [rows]="dataList" [columnMode]="ColumnMode.force"
              [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="limit" [scrollbarH]="true">

              <!-- S.No -->
              <ngx-datatable-column name="S.No" [width]="70">
                <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">
                  {{ rowIndex + 1 }}
                </ng-template>
              </ngx-datatable-column>

              <!-- Dynamic Columns -->
              <ngx-datatable-column *ngFor="let field of listFields" [name]="field.fieldName" [prop]="field.field"
                [width]="190">

                <ng-template ngx-datatable-cell-template let-row="row">

                  <ng-container [ngSwitch]="field.field">

                    <!-- ICON -->
                    <img *ngSwitchCase="'icon'" class="img-fluid rounded-circle" style="max-height:40px"
                      [src]="row.icon ? env.url + '/file/billerIcons/' + row.icon : 'assets/images/no-img.jpg'"
                      [alt]="row.billerName" />

                    <!-- FULL NAME -->
                    <span *ngSwitchCase="'full_name'">
                      {{ row?.full_name | titlecase }}
                    </span>

                    <!-- COMBINED NAME -->
                    <span *ngSwitchCase="'first_name'">
                      {{ hp.constructName(row.first_name, row.middle_name, row.last_name) }}
                    </span>

                    <!-- TRIM -->
                    <span *ngSwitchCase="'blr_name'">
                      {{ hp.trimString(row?.blr_name, 25) }}
                    </span>

                    <!-- AMOUNTS -->
                    <span *ngSwitchCase="'amount'">₹ {{ GetFieldByIndex(row, field.field) }}</span>
                    <span *ngSwitchCase="'balance'">₹ {{ GetFieldByIndex(row, field.field) }}</span>
                    <span *ngSwitchCase="'payout_balance'">₹ {{ GetFieldByIndex(row, field.field) }}</span>
                    <span *ngSwitchCase="'lien'">₹ {{ GetFieldByIndex(row, field.field) }}</span>
                    <span *ngSwitchCase="'previous_lien'">₹ {{ GetFieldByIndex(row, field.field) }}</span>
                    <span *ngSwitchCase="'updated_lien'">₹ {{ GetFieldByIndex(row, field.field) }}</span>
                    <span *ngSwitchCase="'previous_balance'">₹ {{ GetFieldByIndex(row, field.field) }}</span>
                    <span *ngSwitchCase="'updated_balance'">₹ {{ GetFieldByIndex(row, field.field) }}</span>
                    <span *ngSwitchCase="'previous_payout_balance'">₹ {{ GetFieldByIndex(row, field.field) }}</span>
                    <span *ngSwitchCase="'updated_payout_balance'">₹ {{ GetFieldByIndex(row, field.field) }}</span>

                    <span *ngSwitchCase="'transfer_amt'">
                      ₹ {{ row?.validate?.transfer_amt || row?.notify?.transfer_amt || 0 }}
                    </span>

                    <!-- DATES -->
                    <span *ngSwitchCase="'updated_at'">{{ GetFieldByIndex(row, field.field) | date:'medium' }}</span>
                    <span *ngSwitchCase="'created_at'">{{ GetFieldByIndex(row, field.field) | date:'medium' }}</span>

                    <!-- UPDATED BY -->
                    <span *ngSwitchCase="'updated_by'">
                      QT-{{ row?.updated_by === 'self' ? 100000 : row?.updated_by }}
                    </span>

                    <span *ngSwitchCase="'created_by'">
                      QT-{{ row?.created_by === 'self' ? 100000 : row?.created_by }}
                    </span>

                    <!-- QUINTUS ID -->
                    <span *ngSwitchCase="'quintus_id'">
                      QT-{{ GetFieldByIndex(row, field.field) }}
                    </span>

                    <!-- STATUS BADGE -->
                    <ng-container *ngSwitchCase="'status'">
                      <ng-container *ngLet="(GetFieldByIndex(row, field.field) || '').toString() as status">
                        <span class="badge badge-pill text-capitalize" [ngClass]="{
                            'badge-success': status === 'success' || status === 'refund',
                            'badge-danger': status.includes('failed') || status === 'error',
                            'badge-warning': status === 'initiated',
                            'badge-info': status === 'pending' || status === 'awaited'
                          }">
                          {{ status || 'NA' }}
                        </span>
                      </ng-container>
                    </ng-container>

                    <!-- DEFAULT -->
                    <span *ngSwitchDefault>
                      {{ GetFieldByIndex(row, field.field) }}
                    </span>

                  </ng-container>
                </ng-template>
              </ngx-datatable-column>

              <!-- ACTIONS -->
              <ngx-datatable-column name="Actions" [width]="180"
                *ngIf="showAction?.edit || showAction?.payout || showAction?.view || showAction?.delete || showAction?.download">
                <ng-template ngx-datatable-cell-template let-row="row">

                  <button *ngIf="showAction?.edit" class="btn btn-primary btn-sm btn-rounded mx-1"
                    [routerLink]="editRoutePath + '/' + row[editKey]">
                    <i class="ft-edit"></i>
                  </button>

                  <button *ngIf="showAction?.payout" class="btn btn-primary btn-sm btn-rounded mx-1"
                    [routerLink]="editRoutePayoutPath + '/' + row[editKey]">
                    Payout <i class="ft-edit"></i>
                  </button>

                  <button *ngIf="showAction?.view" class="btn btn-primary btn-sm btn-rounded mx-1"
                    [routerLink]="viewRoutePath + '/' + row[editKey]"
                    [queryParams]="param1 ? { param1: row[param1], param2: row[param2] } : null">
                    <i class="ft-eye"></i>
                  </button>

                  <button *ngIf="showAction?.delete" class="btn btn-danger btn-sm btn-rounded mx-1"
                    (click)="deleteService(row._id)">
                    <i class="ft-trash-2"></i>
                  </button>

                  <a href="javascript:void(0)" *ngIf="showAction?.download" (click)="download(row[editKey])">
                    <i class="fa fa-file-excel"></i>
                  </a>

                </ng-template>
              </ngx-datatable-column>

            </ngx-datatable>

            <!-- PAGINATION SECTION -->
            <div class="d-flex justify-content-between align-items-center mt-2 flex-wrap">

              <!-- Buttons -->
              <div class="d-flex align-items-center mb-2">
                <button class="btn btn-primary btn-sm mx-1" [disabled]="page === 1"
                  (click)="previousPage()">Previous</button>

                <span> Page {{ page }} of {{ totalPages }} </span>

                <button class="btn btn-primary btn-sm mx-1" [disabled]="page === totalPages"
                  (click)="nextPage()">Next</button>
              </div>


              <!-- Page Size -->
              <div class="d-flex align-items-center mb-2">
                <label class="mr-2 mb-0">Rows per page:</label>
                <select [(ngModel)]="limit" (change)="onLimitChange()" class="form-control w-auto">
                  <option *ngFor="let s of pageSizes" [value]="s">{{ s }}</option>
                </select>
              </div>



            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>